import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const ApplicationsAdmin = () => {
    const [applications, setApplications] = useState([]);

    useEffect(() => {
        fetch('http://localhost:5000/api/applications')
            .then(res => res.json())
            .then(data => setApplications(data));
    }, []);

    return (
        <div>
            <h2>Manage Applications</h2>
            <table>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Job Applied</th>
                        <th>Resume</th>
                    </tr>
                </thead>
                <tbody>
                    {applications.map(app => (
                        <tr key={app.id}>
                            <td>{app.name}</td>
                            <td>{app.email}</td>
                            <td>{app.job}</td>
                            <td>
                                <Link to={`http://localhost:5000/${app.resumePath}`} target="_blank" rel="noreferrer">
                                    Download
                                </Link>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default ApplicationsAdmin;
